import { useState } from 'react'

export default function useIsFocusWithin() {
  const [isFocusWithin, setIsFocusWithin] = useState(false)

  const onFocus: React.FocusEventHandler = () => {
    setIsFocusWithin(true)
  }

  const onBlur: React.FocusEventHandler = (event) => {
    setIsFocusWithin(event.currentTarget.contains(event.relatedTarget))
  }

  return {
    isFocusWithin,
    containerProps: {
      onFocus,
      onBlur
    }
  }
}
